import { strings } from "@/constants";
import type { CompanyType } from "@/types";

import { CompanyRow } from "./company-row";

export const CompaniesList = ({
    companies,
    isLoading,
}: {
    companies: CompanyType[],
    isLoading: boolean,
}) => (
    <div
        className="
            overflow-hidden
            rounded-default
            border
            border-gray-200
            bg-surface
            shadow-sm
        "
    >
        {isLoading ? (
            <div
                className="
                    px-6
                    py-12
                    text-center
                    text-sm
                    text-text-secondary
                "
            >
                {strings.admin.loading}
            </div>
        ) : companies.length === 0 ? (
            <div
                className="
                    px-6
                    py-12
                    text-center
                    text-sm
                    text-text-secondary
                "
            >
                {strings.admin.emptyCompanies}
            </div>
        ) : (
            <ul className="divide-y divide-gray-100">
                {companies.map((company) => (
                    <CompanyRow
                        company={company}
                        key={company.id}
                    />
                ))}
            </ul>
        )}
    </div>
);
